import * as React from "react"
import {Box, Typography} from "@mui/material";
import {IconSeeker} from "@ui-seeker/core";

export default function PageWrapperErrorPage() {
    const boxStyles = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        //bgcolor: 'background.paper',
        padding: 3,
        //borderRadius: 2,
        //boxShadow: 2,
        textAlign: 'center',
        mt: 10
    }

    return <Box sx={boxStyles} >
        <IconSeeker icon={'server'} sx={{ fontSize: 50, color: 'text.secondary', mb: 1 }} />

        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'text.primary', mt: 1 }}>
            We're sorry but the system is currently busy. Please try again in a few minutes.
        </Typography>

        <Typography variant="body2" sx={{ color: 'text.secondary',  mt: 1 }}>
            If the issue persists, feel free to contact support. We've likely already been alerted and are working on it.
        </Typography>
    </Box>
}